import React from "react";

const UpdatetickIcon = ({ width = 20, height = 20, color = "#428B00", ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={width}
            height={height}
            viewBox="0 0 15 15"
            enableBackground="new 0 0 15 15"
            {...props}
        >
            <path
                fill={color}
                stroke={color}
                strokeWidth="0.5"
                d="M5.7,12.1c-0.2,0.2-0.4,0.3-0.6,0.3s-0.4-0.1-0.6-0.3L1.1,8.6l1.1-1.1l3,3l7.9-7.9l1.1,1.1L5.7,12.1z"
            />
        </svg>
    );
};

export default UpdatetickIcon;